import { createMemoStyles } from '@wds/styles';
var useStyles = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing;
  return {
    actions: {
      display: 'flex',
      marginRight: spacing[4],
      '& > a, & > button': {
        border: 'none',
        margin: "0 ".concat(spacing[1], "px"),
        textDecoration: 'none'
      }
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map